<template>
  <layout-default-appbar
    :back-to="true">
    Transmissão
  </layout-default-appbar>
</template>

<script>

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewSincronizarEnviarAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {

    };
  },
};
</script>
